import confetti from "canvas-confetti";

const PRIMARY = "#D05C35";
const ACCENT = "#2F4858";
const SUCCESS = "#3A7D66";
const WARM = "#E6B980";

export function celebrateWin() {
  const duration = 2500;
  const end = Date.now() + duration;
  const interval = setInterval(() => {
    if (Date.now() > end) return clearInterval(interval);
    confetti({
      particleCount: 3,
      angle: 60, spread: 55,
      origin: { x: 0, y: 0.7 },
      colors: [PRIMARY, ACCENT, SUCCESS, WARM],
    });
    confetti({
      particleCount: 3,
      angle: 120, spread: 55,
      origin: { x: 1, y: 0.7 },
      colors: [PRIMARY, ACCENT, SUCCESS, WARM],
    });
  }, 200);
}

export function celebrateSmall() {
  confetti({
    particleCount: 60,
    spread: 70,
    startVelocity: 30,
    origin: { y: 0.6 },
    colors: [PRIMARY, ACCENT, SUCCESS],
  });
}
